import type { Subscription } from '../../../../../types';

import * as styles from './trigger.css';
import CANCELLATION_ELIGIBLE_STATES from '../../../../../constants/cancellation-eligible-states';
import CancelPlanDialog from './dialog';
import { CaretRight as CaretRightIcon } from '@phosphor-icons/react';
import SUB_STATUSES from '../../../../../constants/sub-statuses';
import { TrackedLink } from '@blueshift-ui/analytics';
import clsx from 'clsx';
import useAddress from '../../../../../hooks/use-address';
import useFeatureFlags from '@blueshift-ui/auth/dist/hooks/use-feature-flags';
import { useState } from 'react';

interface CancelPlanDialogTriggerProps {
  children: React.ReactNode;
  className?: string;
  subscription: Subscription;
}

function CancelPlanDialogTrigger({
  children,
  className,
  subscription,
  ...linkProps
}: CancelPlanDialogTriggerProps) {
  const { data: address, isLoading: isAddressLoading } = useAddress({
    clientUuid: subscription.client_uuid,
  });
  const { flags } = useFeatureFlags();

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  function handleTriggerClick() {
    setIsDialogOpen(true);
  }

  function handleDialogClose() {
    setIsDialogOpen(false);
  }

  if (
    isAddressLoading ||
    !address?.state ||
    !CANCELLATION_ELIGIBLE_STATES.includes(address?.state) ||
    !flags['kzn-879-self-service-cancellation'] ||
    subscription.sub_statuses?.some(
      (subStatus) =>
        subStatus === SUB_STATUSES.DEACTIVATION_PENDING_BILLING_CYCLE ||
        subStatus === SUB_STATUSES.DEACTIVATION_PENDING_CONTRACT
    )
  ) {
    return null;
  }

  return (
    <>
      <TrackedLink
        {...linkProps}
        className={clsx(styles.cancelPlanLink, className)}
        id="cancel_plan_link"
        onClick={handleTriggerClick}
      >
        {children}
        <CaretRightIcon />
      </TrackedLink>

      <CancelPlanDialog
        onClose={handleDialogClose}
        open={isDialogOpen}
        subscriptionId={subscription.id}
      />
    </>
  );
}

export default CancelPlanDialogTrigger;
